module.exports = __webpack_public_path__ + "static/media/toggle-off.db9ff8e0.svg";